import { render, staticRenderFns } from "./perks.vue?vue&type=template&id=75c58fa8&scoped=true&"
import script from "./perks.vue?vue&type=script&lang=js&"
export * from "./perks.vue?vue&type=script&lang=js&"
import style0 from "./perks.vue?vue&type=style&index=0&id=75c58fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c58fa8",
  null
  
)

export default component.exports